<template>
	<div>
		<az-toolbar @click="carregarInformacoesBotaoFiltro">
			<template #actions>
				<menu-gerar-ata></menu-gerar-ata>
			</template>
			<template #simpleSearch>
				<az-search
					class="advanced-search-ata"
					:filter="filtro"
					v-az-auth="permissoes.ataListar"
					simple-search-placeholder="Busque por N° Ata, Processo, Edital ou Descrição"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
					@advanced-search="buscar"
					@clear="limparBusca"
				>
					<template #search-items>
						<az-search-item>
							<v-text-field label="Objeto" v-model="filtroInterno.objeto.value"></v-text-field>
						</az-search-item>
						<az-search-item>
							<v-text-field label="Fornecedor" v-model="filtroInterno.razaoSocial.value"></v-text-field>
						</az-search-item>
						<az-search-item>
							<v-text-field
								label="Descrição do item"
								v-model="filtroInterno.descricaoItemAta.value"
							></v-text-field>
						</az-search-item>
						<az-search-item>
							<v-text-field
								label="Código do item"
								v-model="filtroInterno.codigoItemAta.value"
							></v-text-field>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Atividade do Pedido" class="mb-0"></label-personalizado>
							<v-autocomplete
								placeholder="Selecione a atividade do pedido"
								clearable
								outlined
								dense
								:items="atividadesPedido"
								item-text="nomeAtividade"
								item-value="idAtividade"
								@change="onAtividadePedidoChange"
								v-model="atividadePedidoSelecionada"
							></v-autocomplete>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Atividade da Adesão" class="mb-0"></label-personalizado>
							<v-autocomplete
								placeholder="Selecione a atividade da adesão"
								clearable
								outlined
								dense
								:items="atividadesAdesao"
								item-text="nomeAtividade"
								item-value="idAtividade"
								@change="onAtividadeAdesaoChange"
								v-model="atividadeAdesaoSelecionada"
							></v-autocomplete>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Órgão"></label-personalizado>
							<v-autocomplete
								id="combo-autocomplete-ata"
								v-model="orgao"
								name="Órgão"
								outlined
								dense
								no-filter
								clearable
								:items="listaOrgaos"
								placeholder="Selecione o órgão"
								class="pt-0"
								item-value="idOrgao"
								item-text="siglaDescricao"
								:filter="orgaoFilter"
								:search-input.sync="campoBusca"
								@update:search-input.capture="buscarOrgaos()"
								@click:clear="orgao = null"
								return-object
							>
								<template #item="{ item, attrs, on }">
									<v-list-item v-bind="attrs" v-on="on">
										<v-list-item-content>
											<texto-tooltip
												:tamanho-maximo="35"
												:texto="item.siglaDescricao"
											></texto-tooltip>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-autocomplete>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Atas"></label-personalizado>
							<v-radio-group v-model="vigencia" row name="Atas" mandatory>
								<v-radio
									v-for="filtroVigenciaAta in getFiltroVigenciaAta"
									:key="filtroVigenciaAta.value"
									:label="filtroVigenciaAta.text"
									:value="filtroVigenciaAta.value"
								></v-radio>
							</v-radio-group>
						</az-search-item>
					</template>
				</az-search>
			</template>
		</az-toolbar>
		<az-container class="listagem">
			<painel-com-tabs-sem-rotas :tabs="tabs" :hide-slider="false" layout="SEM_BORDA">
				<template #atas>
					<ata-listagem
						:itens="datasource"
						:total-paginas="totalPaginas"
						:total-itens="totalItens"
						:paginacao="paginacao"
						@paginar="setPaginacaoAtaListagem"
						@resetar-page="resetarPaginaItemAtaListagem()"
					></ata-listagem>
				</template>
				<template #adesoes v-az-auth="permissoes.ataEditar">
					<listagem-adesoes-collapses></listagem-adesoes-collapses>
				</template>
			</painel-com-tabs-sem-rotas>
		</az-container>
	</div>
</template>

<script>
import AtaListagem from './listagem/AtaListagem'
import MenuGerarAta from '@/views/pages/ata/gerar-ata/MenuGerarAta'
import { actionTypes, filtroVigenciaAta, getterTypes } from '@/core/constants'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
import mutationTypes from '@/core/constants/mutation-types'
import PainelComTabs from '@/views/components/PainelComTabs.vue'
import PainelComTabsSemRotas from '@/views/components/PainelComTabsSemRotas.vue'
import { TabSemRotaUtils } from '@/core/utils'
import ListagemAdesoesCollapses from '@/views/pages/ata/pesquisa/listagem-collapses/ListagemAtasCollapses.vue'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import HighlightBuscaFilter from '@/views/filters/highlight-busca-filter'

export default {
	name: 'ata-todos',
	components: {
		TextoTooltip,
		LabelPersonalizado,
		ListagemAdesoesCollapses,
		PainelComTabsSemRotas,
		PainelComTabs,
		AtaListagem,
		MenuGerarAta,
	},
	filters: { HighlightBuscaFilter },
	mixins: [permissoesMixin],
	data() {
		return {
			isComponenteAtivo: true,
			datasource: [],
			totalPaginas: 0,
			tabs: [],
			totalItens: 0,
			filtroInterno: this.getFiltros(),
			paginacao: this.$store.state.ata.paginacao,
			quantidadeAdesoes: 0,
			atividadesPedido: [],
			atividadesAdesao: [],
			listaOrgaos: [],
			orgaoSelecionado: null,
			atividadePedidoSelecionada: null,
			atividadeAdesaoSelecionada: null,
			campoOrgao: null,
			filtrosButton: null,
			vigencia: null,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.ata.filtro,
			ata: (state) => state.ata,
		}),
		...mapGetters({
			orgaoLogado: getterTypes.COMUM.GET_ORGAO_LOGADO,
		}),
		orgao: {
			get() {
				return this.orgaoSelecionado
			},
			set(orgao) {
				this.orgaoSelecionado = orgao
				this.filtroInterno.siglaOrgao.value = orgao?.siglaOrgao
				this.campoOrgao = ''
				this.$store.commit(mutationTypes.ATA.SET_ID_ORGAO_ABA, orgao?.idOrgao)
			},
		},
		campoBusca: {
			get() {
				return this.campoOrgao
			},
			set(valor) {
				this.campoOrgao = valor ? valor.trim() : null
			},
		},
		getFiltroVigenciaAta() {
			return Object.values(filtroVigenciaAta)
		},
	},
	async mounted() {
		await Promise.all([
			await this.atualizarSessaoParaConseguirPegarOsPerfisDoUsuarioNoBackEnd(),
			this.$store.commit(mutationTypes.ATA.RESET_INFORMACOES_ATA),
			await this.carregarAtas(),
			await this.criarTabs(),
		])
		this.forcarExibirFiltrosAvancados()
		this.$nextTick(() => {
			this.adicionarListenerBotaoFiltro()
		})
		this.vigencia = this.filtro.vigenciaAta.value || this.filtro.vigenciaAta.default
	},
	beforeDestroy() {
		this.isComponenteAtivo = false
		this.removerListenerBotaoFiltro()
	},
	methods: {
		async carregarInformacoesBotaoFiltro() {
			await Promise.all([this.buscarAtividades(), this.buscarOrgaos()])
		},
		manipularCliqueBotaoFiltro() {
			this.carregarInformacoesBotaoFiltro()
			this.forcarExibirFiltrosAvancados()
		},
		orgaoFilter(item, queryText) {
			const textoSigla = item.siglaOrgao.toLowerCase()
			const textoNome = item.nomeOrgao.toLowerCase()
			const searchText = queryText.toLowerCase().trim()
			this.campoOrgao = queryText
			return textoSigla.indexOf(searchText) > -1 || textoNome.indexOf(searchText) > -1
		},
		adicionarListenerBotaoFiltro() {
			if (this.filtrosButton) {
				this.filtrosButton.removeEventListener('click', this.manipularCliqueBotaoFiltro)
			}

			this.filtrosButton = this.$el.querySelector('.btn-advanced-search')

			if (this.filtrosButton) {
				this.filtrosButton.addEventListener('click', this.manipularCliqueBotaoFiltro)
			}
		},
		removerListenerBotaoFiltro() {
			if (this.filtrosButton) {
				this.filtrosButton.removeEventListener('click', this.manipularCliqueBotaoFiltro)
				this.filtrosButton = null
			}
		},
		async atualizarSessaoParaConseguirPegarOsPerfisDoUsuarioNoBackEnd() {
			await this.$store.dispatch(actionTypes.COMUM.ATUALIZAR_SESSAO, this.orgaoLogado)
		},
		getFiltros() {
			return _.cloneDeep(this.$store.state.ata.filtro)
		},
		async removerFiltros(propriedade) {
			if (propriedade === 'atividadeAdesao') this.removerCampoAtividadeAdesaoDoFiltro()
			if (propriedade === 'atividadePedido') this.removerCampoAtividadePedidoDoFiltro()
			if (propriedade === 'siglaOrgao') this.limparCampoOrgaoDaBusca()
			if (propriedade === 'vigenciaAta') this.limparCampoVigenciaAta()

			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
				this.filtroInterno[propriedade].value = this.filtroInterno[propriedade].default
			}
			await this.carregarAtas()
		},
		async buscar(searchText) {
			if (searchText) this.filtro.numeroAtaNumeroProcessoOuDescricao.value = searchText
			this.filtro.objeto.value = this.filtroInterno.objeto.value
			this.filtro.razaoSocial.value = this.filtroInterno.razaoSocial.value
			this.filtro.descricaoItemAta.value = this.filtroInterno.descricaoItemAta.value
			this.filtro.codigoItemAta.value = this.filtroInterno.codigoItemAta.value
			this.filtro.siglaOrgao.value = this.filtroInterno.siglaOrgao.value
			this.filtro.vigenciaAta.value = this.vigencia

			const payload = {
				idOrgao: this.orgaoSelecionado?.idOrgao,
				siglaOrgao: this.filtroInterno.siglaOrgao.value,
			}

			this.filtro.isAtaSemProcesso = { ...this.filtroInterno.isAtaSemProcesso }
			this.setAtividadeNaState()
			this.resetarPaginaItemAtaListagem()
			await this.carregarAtas(payload)
		},
		async carregarAtas(payload) {
			const retorno = await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_FILTRO, payload)
			this.totalPaginas = retorno.totalPages
			this.totalItens = retorno.totalElements
			this.datasource = retorno.itens
		},
		async buscarOrgaos() {
			const campoOrgao = this.orgao ? this.orgao.siglaOrgao : this.campoOrgao?.trim()
			const orgaos = await this.$store.dispatch(actionTypes.ATA.BUSCAR_ORGAOS_FILTRO, campoOrgao)
			this.listaOrgaos = orgaos.itens
		},
		setPaginacaoAtaListagem(paginacao) {
			this.$store.commit(mutationTypes.ATA.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarAtas()
		},
		limparBusca() {
			this.$store.commit(mutationTypes.ATA.LIMPAR_FILTRO_LISTAGEM)
			this.filtroInterno = this.getFiltros()
			this.removerCampoAtividadePedidoDoFiltro()
			this.removerCampoAtividadeAdesaoDoFiltro()
			this.limparCampoOrgaoDaBusca()
			this.limparCampoVigenciaAta()
			this.carregarAtas()
		},
		resetarPaginaItemAtaListagem() {
			this.$store.commit(mutationTypes.ATA.RESETAR_PAGINA_LISTAGEM)
		},
		forcarExibirFiltrosAvancados() {
			if (!this.isComponenteAtivo) return
			let componenteBusca = this.$refs.componenteAzSearch
			componenteBusca.hasAdvancedSearchItems = true
		},
		async criarTabs() {
			const retorno = await this.$store.dispatch(actionTypes.ADESAO.BUSCAR_QUANTIDADE_ADESOES)

			this.tabs = [new TabSemRotaUtils('ata', 'Atas', 'atas', () => true)]

			if (retorno.possuiAdesao === true) {
				this.tabs.push(
					new TabSemRotaUtils(
						'adesao',
						'Adesões',
						'adesoes',
						() => true,
						retorno.quantidadeAdesoes.toString(),
						this.textoPossuiAdesao(retorno.quantidadeAdesoes.toString()),
					),
				)
			}
		},
		textoPossuiAdesao(valor) {
			return valor > 1 ? valor + ' adesões para receber.' : valor + ' adesão para receber.'
		},
		async buscarAtividades() {
			let { itens } = await this.$store.dispatch(actionTypes.ATA.BUSCAR_ATIVIDADES_FILTRO)
			this.atividadesPedido = itens[0].atividadesPedido
			this.atividadesAdesao = itens[0].atividadesAdesao
		},
		setAtividadeNaState() {
			let temAtividadePedido = this.temAtividadePedidoSelecionado()
			let temAtividadeAdesao = this.temAtividadeAdesaoSelecionada()

			if (temAtividadeAdesao) {
				this.filtro.atividadeAdesao.value = this.atividadeAdesaoSelecionada.nomeAtividade
				this.$store.state.ata.idAtividadeAdesao.value = this.atividadeAdesaoSelecionada.idAtividade
			}

			if (temAtividadePedido) {
				this.filtro.atividadePedido.value = this.atividadePedidoSelecionada.nomeAtividade
				this.$store.state.ata.idAtividadePedido.value = this.atividadePedidoSelecionada.idAtividade
			}
		},
		temAtividadePedidoSelecionado() {
			if (this.atividadePedidoSelecionada) return true
			this.limparCampoAtividadePedidoDaBusca()
			return false
		},
		temAtividadeAdesaoSelecionada() {
			if (this.atividadeAdesaoSelecionada) return true
			this.limparCampoAtividadeAdesaoDaBusca()
			return false
		},
		removerCampoAtividadePedidoDoFiltro() {
			this.limparCampoAtividadePedidoDaBusca()
			this.atividadePedidoSelecionada = null
		},
		removerCampoAtividadeAdesaoDoFiltro() {
			this.limparCampoAtividadeAdesaoDaBusca()
			this.atividadeAdesaoSelecionada = null
		},
		limparCampoAtividadePedidoDaBusca() {
			this.filtro.atividadePedido.value = this.$store.state.ata.idAtividadePedido.value = null
		},
		limparCampoAtividadeAdesaoDaBusca() {
			this.filtro.atividadeAdesao.value = this.$store.state.ata.idAtividadeAdesao.value = null
		},
		onAtividadePedidoChange(idAtv) {
			this.atividadePedidoSelecionada =
				this.atividadesPedido.find((atividade) => atividade.idAtividade === idAtv) || null
		},
		onAtividadeAdesaoChange(idAtv) {
			this.atividadeAdesaoSelecionada =
				this.atividadesAdesao.find((atividade) => atividade.idAtividade === idAtv) || null
		},
		limparCampoOrgaoDaBusca() {
			this.$store.commit(mutationTypes.ATA.RESET_ID_ORGAO_ABA)
			this.orgaoSelecionado = null
		},
		limparCampoVigenciaAta() {
			this.filtro.vigenciaAta.value = null
			this.vigencia = this.filtro.vigenciaAta.default
		},
	},
}
</script>

<style lang="stylus">
.advanced-search-bar
	top: 23px !important
	height: calc(100% - 23px) !important

@media screen and (min-width: 750px)
	.input-search
		width 350px !important

.advanced-search-ata .simple-search .input-search
	overflow-x scroll
	scrollbar-width: none

.filtro-orgao-selecionado
	font-size: 13px !important

.v-radio .v-input--selection-controls__input
		margin-right 6px !important

.v-radio .v-label
		font-size 14px
</style>
